import React, { useEffect, useState } from 'react';
import { useRouter } from '../router';
var Loader = function (props) {
    var children = props.children, onLoadingStart = props.onLoadingStart, onLoadingComplete = props.onLoadingComplete, _a = props.delay, delay = _a === void 0 ? 0 : _a;
    var _b = useRouter(), loading = _b.loading, dataLoading = _b.dataLoading;
    var _c = useState(dataLoading), customLoading = _c[0], setCustomLoading = _c[1];
    var _d = useState(false), waitingDelay = _d[0], setWaitingDelay = _d[1];
    useEffect(function () {
        if (onLoadingStart)
            onLoadingStart(setCustomLoading);
        return function () {
            if (onLoadingComplete)
                onLoadingComplete();
        };
    }, []);
    useEffect(function () {
        if (waitingDelay)
            return;
        if (customLoading && !dataLoading) {
            setWaitingDelay(true);
            setTimeout(function () {
                setCustomLoading(false);
                setWaitingDelay(false);
            }, delay);
        }
        else {
            setCustomLoading(dataLoading);
        }
    }, [dataLoading]);
    var loaderContent = children || React.createElement("p", null, "Loading...");
    if (customLoading || dataLoading || loading) {
        return loaderContent;
    }
    return React.createElement(React.Fragment, null);
};
export default Loader;
//# sourceMappingURL=Loader.js.map